import React, { useRef } from 'react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

function Hero({calendlyFormRef, onCtaClick }) {
  const navigate = useNavigate();

  useCalendlyEventListener({
    onEventScheduled: (event) => {
      console.log("Event booked:", event.data.payload);
      navigate("/thank-you");
    },
  });

  return (
    <div className="ttc-hero-main-wrapper position-relative">
      
      <video 
        className="ttc-hero-bg-video" 
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/videos/landing-hero-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div style={{position:"absolute",zIndex:"1",width:"100%",height:"100%", background:"rgba(0, 0, 0, 0.489)"}}></div>
      <div className="container position-relative ttc-hero-content-layer">
       
        <header className="ttc-hero-navbar d-flex align-items-center justify-content-sm-between justify-content-center py-4">
          <div className="ttc-hero-logo-container">
            <img 
              src="/images/icons/nav-logo.png" 
              alt="The Toronto Clinic Logo" 
              className="ttc-hero-logo img-fluid"
            />
          </div>
          <div className="d-flex align-items-center gap-3">
            <a href="tel:416-849-5555" className="btn ttc-hero-btn-outline d-none d-sm-inline-flex align-items-center gap-2">
              <span>416-849-5555</span>
              <span className="ttc-hero-btn-icon">↗</span>
            </a>
            <button 
              type="button" 
              onClick={onCtaClick} 
              className="btn ttc-hero-btn-primary d-none d-sm-inline-flex align-items-center gap-2"
            >
              <span>Explore Membership</span>
              <span className="ttc-hero-btn-icon">↗</span>
            </button>
          </div>
        </header>

        <div className="row align-items-center py-5 gy-5">
          
          <div className="col-12 col-lg-6 text-white">
            <h1 className="ttc-hero-title mb-4">
              Raising The Bar On <br />
              <span className="ttc-hero-title-italic">Personalized Care</span>
            </h1>
            <p className="ttc-hero-subtitle mb-4 me-lg-4">
              A Concierge Approach To Proactive Executive Healthcare, Designed To Optimize Longevity, Performance, And Peace Of Mind.
            </p>
            <button 
              type="button" 
              onClick={onCtaClick} 
              className="btn ttc-hero-btn-primary btn-lg d-inline-flex align-items-center gap-2 px-4 py-3"
            >
              <span>Book A Consultation</span>
              <span className="ttc-hero-btn-icon">↗</span>
            </button>
          </div>

          <div className="col-12 col-lg-6">
            <div 
              ref={calendlyFormRef} 
              className="ttc-hero-form-card rounded-4 overflow-hidden shadow-lg"
            >
              <InlineWidget 
                url="https://calendly.com/ttc55avenue/membership-appointment"
                styles={{ height: '650px', width: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;